import { useEffect, useState } from 'react';

/** Read `#token=…` from the address once, then remove it from the address bar and history. */
export function useHashToken(): string | null {
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('token'));
  useEffect(() => {
    window.history.replaceState(null, '', window.location.pathname);
  }, []);
  return token;
}
